import { render, staticRenderFns } from "./editProfileConvocation.vue?vue&type=template&id=a024e1b0"
import script from "./editProfileConvocation.vue?vue&type=script&lang=js"
export * from "./editProfileConvocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports